import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ConfirmDialog } from 'primeng/confirmdialog';
import { ButtonComponent } from '../button/button';

@Component({
  selector: 'app-confirm-dialog',
  imports: [ConfirmDialog, ButtonComponent],
  templateUrl: './confirm-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.css'
})
export class ConfirmDialogComponent {

}
